import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const fetchData = createApi('contracts', 'GET');

const Contracts = createSlice({
  name: 'Contracts',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {
    updateContractsData: (state, action) => {
      state.data = {
        ...state.data,
        contractDataOutputList: action.payload
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export const { updateContractsData } = Contracts.actions;
export default Contracts.reducer;